(() => {
  const supported = new Map(window.SITE_LANGUAGES);
  const dictionaries = {};
  for (const [code, pack] of Object.entries(window.SITE_PACKS)) {
    const words = pack.split('|');
    if (words.length !== SITE_WORDS.length || SITE_NOTE_PACKS[code].length !== SITE_NOTES.length) throw new Error(`Incomplete locale: ${code}`);
    dictionaries[code] = Object.fromEntries([...SITE_WORDS.map((key,i)=>[key,words[i]]), ...SITE_NOTES.map((key,i)=>[key,SITE_NOTE_PACKS[code][i]])]);
    dictionaries[code]['Carry Equipment'] = dictionaries[code]['CARRY EQUIPMENT'];
  }
  const keys = [...SITE_WORDS, ...SITE_NOTES, 'Carry Equipment'].sort((a,b)=>b.length-a.length);
  const pattern = new RegExp(keys.map(key=>key.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')).join('|'), 'g');
  let language = 'zh-CN';
  try { const saved = localStorage.getItem('adrian-language'); if (supported.has(saved)) language = saved; } catch {}
  // One-pass substitution prevents translation output from being translated a second time.
  window.siteTranslate = text => {
    if(language === 'zh-CN') return String(text).replace(/Language/g,'语言');
    const output=String(text).replace(pattern, key=>dictionaries[language][key] ?? key);
    const punctuated=['zh-TW','ja'].includes(language)?output:output.replace(/：/g,': ').replace(/，/g,', ').replace(/；/g,'; ');
    return language==='ar'?punctuated.replace(/\d+(?:\s*×\s*\d+)+\s*cm/g,value=>'\u2066'+value+'\u2069'):punctuated;
  };
  const textRecords = new WeakMap();
  const attributeRecords = new WeakMap();
  const excluded = 'script,style,noscript,[data-no-translate]';
  function translateText(node) {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    const old = textRecords.get(node);
    const source = old && old.output === node.nodeValue ? old.source : node.nodeValue;
    const output = siteTranslate(source);
    textRecords.set(node,{source,output});
    if(node.nodeValue !== output) node.nodeValue = output;
  }
  function translateAttributes(el) {
    if (el.closest(excluded)) return;
    const records = attributeRecords.get(el) || {};
    for(const key of ['aria-label','alt','title','placeholder']) {
      if(!el.hasAttribute(key)) continue;
      const value = el.getAttribute(key), old = records[key];
      const source = old && old.output === value ? old.source : value;
      const output = siteTranslate(source);
      records[key] = {source,output};
      if(value !== output) el.setAttribute(key,output);
    }
    attributeRecords.set(el,records);
  }
  function translateTree(root) {
    if(root.nodeType === Node.TEXT_NODE) return translateText(root);
    if(root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    translateAttributes(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    for(let node=walker.nextNode();node;node=walker.nextNode()) {
      if(node.nodeType === Node.TEXT_NODE) translateText(node); else translateAttributes(node);
    }
  }
  const languageControl = document.createElement('label');
  languageControl.className = 'language-control';
  languageControl.innerHTML = '<span>Language</span><select id="site-language" data-no-translate aria-label="Language / 语言"></select>';
  const select = languageControl.querySelector('select');
  for(const [code,name] of supported) { const option=document.createElement('option'); option.value=code; option.lang=code; option.textContent=name; select.append(option); }
  document.querySelector('header').append(languageControl);
  function setLanguage(code, persist=false) {
    if(!supported.has(code)) return;
    language=code; select.value=code;
    document.documentElement.lang=code;
    document.documentElement.dir=code==='ar'?'rtl':'ltr';
    select.setAttribute('aria-label',siteTranslate('Language')+' / Language');
    if(persist) try {localStorage.setItem('adrian-language',code)} catch {}
    translateTree(document.documentElement);
    // Regenerate exported diagrams in the selected language rather than showing a stale export.
    const exportBox=document.querySelector('#custom-export'); if(exportBox) exportBox.hidden=true;
    window.dispatchEvent(new CustomEvent('site-language-change',{detail:{language:code}}));
  }
  select.addEventListener('change',()=>setLanguage(select.value,true));
  const observer=new MutationObserver(records=>{
    const roots=new Set();
    for(const record of records) {
      if(record.type==='childList') record.addedNodes.forEach(node=>roots.add(node));
      else if(record.type==='characterData') translateText(record.target);
      else translateAttributes(record.target);
    }
    roots.forEach(translateTree);
  });
  observer.observe(document.documentElement,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','alt','title','placeholder']});
  setLanguage(language);
})();
